/* eslint-disable */

import React, { Component } from 'react';
import CreatableSelect from 'react-select/creatable';

const components = {
  DropdownIndicator: null,
};
const createOption = label => ({
  label,
  value: label,
});
export default class CreatableInputOnly extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      inputValue: '',
    };
    this.handleChange = (value, actionMeta) => {
      const { onChange } = this.props;
      onChange(value.map(v => v.value));
    };
    this.handleInputChange = inputValue => {
      this.setState({ inputValue });
    };
    this.handleKeyDown = event => {
      const { inputValue } = this.state;
      const { onChange, value } = this.props;
      if (!inputValue) return;
      switch (event.key) {
        case 'Enter':
        case 'Tab':
          const newValue = value.indexOf(inputValue) === -1 ? [...value, inputValue] : value;
          this.setState({
            inputValue: '',
          });
          onChange(newValue);
          event.preventDefault();
      }
    };
  }

  render() {
    const { inputValue } = this.state;
    const { value } = this.props;
    return (
      <CreatableSelect
        components={components}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={this.handleChange}
        onInputChange={this.handleInputChange}
        onKeyDown={this.handleKeyDown}
        placeholder="Type a domain or email address and press enter"
        value={value.map(createOption)}
      />
    );
  }
}
